import { Component, Input, OnInit } from '@angular/core';
import { ModuleName } from 'src/app/shared/enums/ModuleName';

@Component({
  selector: 'star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss'],
})
export class StarRatingComponent implements OnInit {
  moduleName = ModuleName;
  /** Fixed 5-star scale. Answer is 1..5 so a truthy check treats 0 as unanswered. */
  stars: number[] = [1, 2, 3, 4, 5];
  @Input() question;
  @Input() language = 'EN';
  hovered = 0;

  ngOnInit(): void {}

  setRating(value: number): void {
    this.question.answer = value;
  }

  /** How many stars render filled — the hover preview when hovering, otherwise the answer. */
  get activeCount(): number {
    return this.hovered || this.question?.answer || 0;
  }
}
